import { Text } from '@change/ds-core-ui/Text';

import { Translate } from '@change-corgi/core-react/i18n';

export const HeaderTitle: React.FC = () => {
	return (
		<div className="container mt-4 pb-6 md:mt-16">
			<Text
				as="h1"
				variant="display"
				size="medium"
				className="mb-3 text-left md:text-center"
				data-qa="search-landing-heading"
			>
				<Translate value="corgi.search.title" />
			</Text>
			<Text as="p" size="x-large" fontWeight="light" className="mb-3 hidden text-center md:block">
				<Translate value="corgi.search.subtitle" />
			</Text>
		</div>
	);
};
